import { render, staticRenderFns } from "./ModalAddFile.vue?vue&type=template&id=6b96d242&"
import script from "./ModalAddFile.vue?vue&type=script&lang=js&"
export * from "./ModalAddFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports